import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=5e035f1a&"
import script from "./Client.vue?vue&type=script&lang=ts&"
export * from "./Client.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports